// extracted by mini-css-extract-plugin
export var hidden = "_4c-1";
export var leftPanel = "_4c-2";
export var readonlyInspector = "_4c-3";
export var rightPanel = "_4c-0";